import React from "react";
import { Row, Tabs, Tab, Card, Col } from "react-bootstrap";
import { currencyFormat } from '../../Common/Common';

class InviteSubscriptionInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            monthData: [],
            yearData: [],
            productID: '',
            productName: this.props.getUserData().productName,
            planId: this.props.getUserData().price,
            interval:'monthly'
        }
    }
    componentWillMount() {
        this.setState({ monthData: this.props.monthData, yearData: this.props.yearData });
    }
    /**
   * @desc update user data
   * @param {*} data 
   */
    updateUserData(data) {
        this.props.updateUserData("price", data.price.price);
        this.props.updateUserData("productName", data.name);
        this.props.updateUserData("amount", data.price.unit_amount);
        this.props.updateUserData("interval", data.price.recurring.interval);
    }
    render() {

        return (
            <>
                <div className="step-content container-custom pricing">

                    <Tabs defaultActiveKey={localStorage.getItem("interval") == undefined || localStorage.getItem("interval") === "month" ? "monthly" : "annually"} id="uncontrolled-tab-example" className="subscription-tabs">
                        <Tab eventKey="monthly" title="Monthly">
                            <Row><h4 className="col">Select Your Plan</h4></Row>
                            <Row>
                                {this.state.monthData.map(monthData => {
                                    if (monthData.price.isActive && monthData.isActive) {
                                        let description = "<div>" + monthData.description + "</div>";

                                        return (

                                            <Col lg={3} md={6} sm={6} className={`plan-scheme ${this.state.planId === monthData.price.price ? "active-plan" : ''}`} onClick={() => {
                                                this.setState({ planId: monthData.price.price }); this.updateUserData(monthData); localStorage.setItem("interval", monthData.price.recurring.interval)
                                            }}>
                                                <Card className="transaction-single">
                                                    <Card.Body>
                                                        <h4>{monthData.name}</h4>
                                                        <p className="plan-price">{currencyFormat(monthData.price.unit_amount)}/mo.</p>
                                                        <div className="plan-desc">
                                                            <label>Description</label>
                                                            <p className="plan-text" dangerouslySetInnerHTML={{__html:monthData.description}}></p>
                                                            <div className="more-plan-text" dangerouslySetInnerHTML={{__html:description}}>
                                                                
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>

                                            </Col>
                                        )
                                    }
                                })}

                            </Row>
                        </Tab>
                        <Tab eventKey="annually" title="Annually">
                        <Row><h4 className="col">Select Your Plan</h4></Row>
                            <Row>
                                {this.state.yearData.map(yearData => {
                                    if (yearData.price.isActive && yearData.isActive) {
                                        let description = "<div>" + yearData.description + "</div>";

                                        return (

                                            <Col lg={3} md={6} sm={6} className={`plan-scheme ${this.state.planId === yearData.price.price ? "active-plan" : ''}`} onClick={() => { this.setState({ planId: yearData.price.price}); this.updateUserData(yearData); localStorage.setItem("interval", yearData.price.recurring.interval)}}>
                                                <Card className="transaction-single">
                                                    <Card.Body>
                                                        <h4>{yearData.name}</h4>
                                                        <p className="plan-price">{currencyFormat(yearData.price.unit_amount)}/yr.</p>
                                                        <div className="plan-desc">
                                                                    <label>Description</label>
                                                                    <p className="plan-text" dangerouslySetInnerHTML={{__html:yearData.description}}></p>
                                                                    <div className="more-plan-text" dangerouslySetInnerHTML={{__html:description}}>
                                                                        
                                                                    </div>
                                                                </div>
                                                    </Card.Body>
                                                </Card>
                                               
                                            </Col>
                                        )
                                    }
                                })}
                            </Row>
                        </Tab>
                    </Tabs>

                </div>
            </>
        );
    }
}


export default (InviteSubscriptionInfo)